import { useTranslation } from 'react-i18next'

import type { AuditModel } from '@cdab/scania/qpr/offline/models'
import { capitalizeFirstLetter } from '@cdab/utils'
import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

const StyledTdsButton = styled(TdsButton)`
  &&& {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    button {
      display: block;
    }
  }
`

export function PrintDeviationsButton(props: { audit: AuditModel }) {
  const { t } = useTranslation()

  if (props.audit.deviations.length === 0) return null

  return (
    <a
      className='tds-u-flex-dir-col tds-u-w100'
      href={`/audit/${props.audit.id}/action-plan-print`}
      target='_blank'
      rel='noreferrer'
    >
      <StyledTdsButton text={capitalizeFirstLetter(t('deviations'))} />
    </a>
  )
}
